export class WebhookV1StandardPayloadBackupJobSkippedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupJobSkipped",
            "baseName": "backupJobSkipped",
            "type": "WebhookV1BackupJobSkippedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadBackupJobSkippedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
